export default __webpack_public_path__ + "static/media/sort-arrow-down-active.42373326.svg";